export default ({ request }) => ({
  sampleMetadataOptionsListApi(data = {}) {
    return request({
      url: '/master/sampleMetadataOptions/list',
      method: 'post',
      data,
    })
  },
  sampleMetadataOptionsSaveApi(data = {}) {
    return request({
      url: '/master/sampleMetadataOptions/save',
      method: 'post',
      data,
    })
  },
})
